import script from "./ClassView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClassView.vue?vue&type=script&setup=true&lang=ts"

import "./ClassView.vue?vue&type=style&index=0&id=d27f6ab8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d27f6ab8"]])

export default __exports__